import {Injectable, Injector} from '@angular/core';
import {HttpHandler, HttpInterceptor, HttpRequest} from "@angular/common/http";

import {UserService} from "../user.service";
import {UserRole} from "../../enums/UserRole";

@Injectable()
export class TokenInterceptorService implements HttpInterceptor {
  constructor(private injector: Injector) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler) {
    const userService = this.injector.get(UserService);
    const token: string = userService.role === UserRole.USER ? userService.token : userService.adminToken
    let tokenizedReq = request.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    })
    return next.handle(tokenizedReq)
  }
}
